import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { FAQS } from "@/data/site";

export const FAQ = () => (
  <section id="faq" className="py-24 lg:py-36 border-t border-hairline">
    <div className="mx-auto max-w-[1400px] px-6 lg:px-10 grid lg:grid-cols-12 gap-12">
      <div className="lg:col-span-4">
        <h2 className="font-heading uppercase leading-[0.9] tracking-tight text-4xl sm:text-6xl text-stark">
          Frequently<br />asked<br />questions.
        </h2>
        <p className="mt-8 text-concrete leading-relaxed max-w-xs">
          Still not sure? Give us a call on{" "}
          <a href="tel:+447907917551" className="text-brand hover:text-stark transition-colors">07907 917 551</a>{" "}
          and we'll happily talk it through.
        </p>
      </div>

      <div className="lg:col-span-8">
        <Accordion type="single" collapsible className="w-full" data-testid="faq-accordion">
          {FAQS.map((f, i) => (
            <AccordionItem key={i} value={`item-${i}`} className="border-hairline">
              <AccordionTrigger className="text-left font-heading uppercase tracking-tight text-lg lg:text-2xl text-stark hover:text-brand hover:no-underline py-6">
                {f.q}
              </AccordionTrigger>
              <AccordionContent className="text-concrete text-base leading-relaxed pb-6">
                {f.a}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </div>
  </section>
);
